export default "__VITE_ASSET__22393fd2__"